import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Input, Radio, TextArea, Popup, Dialog } from 'antd-mobile';
import { CaretDownOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import carServiceBookingSvg from '../../assets/car-service-booking.svg';
import './common.scss';

export default function CarServiceBookingOrder() {
  const location = useLocation();
  
  // 確保頁面加載時滾動到頂部
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  
  // 預設資料來自 location.state
  const initial = location.state || {
    plate: 'ABC-2156',
    name: '王小明',
    phone: '0912345678',
    serviceType: 'last',
    center: '台北松山服務廠',
    centerAddress: '台北市松山區八德路四段123號',
    date: '2024-07-01',
    time: '09:00',
    wait: 'yes',
    contactTime: '08:30~12:00',
    notify: 'LINE',
    comment: '',
  };

  // 取得服務廠名稱與地址
  const centerDisplay = initial.center && initial.centerAddress
    ? `${initial.center}（${initial.centerAddress}）`
    : initial.center;

  return (
    <div className="center-viewport">
      <div className="maintenance-app">
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" />
          </Link>
        </div>
        <div className="main-content">
          <div className="content-header">
            <div className="header-row">
              <div className="header-text">
                <div className="vehicle-number">{initial.plate}</div>
                <h1 className="page-title">預約保養訂單</h1>
              </div>
              <div className="header-icons">
                <img src={carServiceBookingSvg} alt="預約保養icon" />
              </div>
            </div>
          </div>
          <div className="car-service-container">
            <div className="form-group">
              <label className="form-label">車牌</label>
              <div className="custom-input disabled">{initial.plate}</div>
            </div>
            <div className="form-group">
              <label className="form-label">姓名</label>
              <div className="custom-input disabled">{initial.name}</div>
            </div>
            <div className="form-group">
              <label className="form-label">手機號碼</label>
              <div className="custom-input disabled">{initial.phone}</div>
            </div>
            <div className="form-group">
              <label className="form-label">服務據點</label>
              <div className="custom-input disabled" style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>{centerDisplay}</div>
            </div>
            <div className="form-group">
              <label className="form-label">保養日期</label>
              <div className="custom-input disabled">{initial.date ? dayjs(initial.date).format('YYYY-MM-DD') : ''}</div>
            </div>
            <div className="form-group">
              <label className="form-label">保養時段</label>
              <div className="custom-input disabled">{initial.time}</div>
            </div>
            <div className="form-group">
              <label className="form-label">是否在廠等候？</label>
              <div className="custom-input disabled">{initial.wait === 'yes' ? '是' : '否'}</div>
            </div>
            <div className="form-group">
              <label className="form-label">電話聯絡時段</label>
              <div className="custom-input disabled">{initial.contactTime}</div>
            </div>
            <div className="form-group">
              <label className="form-label">入廠提醒通知方式</label>
              <div className="custom-input disabled">{initial.notify}</div>
            </div>
            <div className="form-group">
              <label className="form-label">其他意見</label>
              <div className="custom-input disabled">{initial.comment}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 